import {EventListeners, MinzeElement} from "minze";
import { Locale } from '../../modules/locale';

export interface TjToastContainer {
  dataMessage: string,
  dataGroupId: string,
}

export class TjToastContainer extends MinzeElement {
  attrs = ["data-message", "data-group-id"];

  destroyToast = () => this.parentNode?.removeChild(this)

  closeToast = () => {
    const lang = Locale.language;
    localStorage.setItem(`${this.dataGroupId}-bannerLastConfirmedMessage-${lang}`, this.dataMessage);
    this.destroyToast()
  }

  html() {
    return `
      <div id="toast-container">
        ${this.dataMessage}
        <button id="close-toast">
          <tj-toast-close-icon></tj-toast-close-icon>
        </button>
      </div>
    `;
  }

  css = () => `
    #toast-container {
      background: #F1F1C4;
      padding: 16px 24px;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: #133762;
      position: relative;
      text-align: center;
    }
    a {
      color: #133762;
    }
    p {
      margin: 0;
    }
    #close-toast {
      cursor: pointer;
      background: none;
      border: none;
      position: absolute;
      right: 24px;
      top: 0;
      bottom: 0;
    }
    tj-toast-close-icon {
      width: 24px;
      height: 24px;
    }
  `;

  eventListeners: EventListeners = [
    ["#close-toast", "click", this.closeToast]
  ];
}
